import { createContext, useContext } from "react";
import { usePrivy, useWallets, useLogin } from "@privy-io/react-auth";

/*
  Real Privy wallet layer. Exposes a stable interface to the app:
  { ready, connected, connecting, address, user, connect, disconnect, getAccessToken }
*/

const WalletContext = createContext(null);

export function WalletProvider({ children }) {
  const { ready, authenticated, user, logout, getAccessToken } = usePrivy();
  const { login } = useLogin();
  const { wallets } = useWallets();

  const address =
    wallets?.[0]?.address || user?.wallet?.address || null;

  const value = {
    ready,
    connected: authenticated,
    connecting: !ready,
    address,
    user,
    connect: () => login(),
    disconnect: () => logout(),
    getAccessToken,
  };

  return <WalletContext.Provider value={value}>{children}</WalletContext.Provider>;
}

export function useWallet() {
  const ctx = useContext(WalletContext);
  if (!ctx) throw new Error("useWallet must be used within WalletProvider");
  return ctx;
}
